import styled, { css } from 'styled-components'
import { H2, Flex, Wrapper } from '@raysync/common/components'
import { Media, hideScrollbar } from '@raysync/common/theme'

export const SectionWrapper = styled.div`
  width: 100%;
  background: #f5f7fb;
  /* background: linear-gradient(to right, #f5f7fb 50%, white 50%); */
  position: relative;
  ${Media.phone`
    padding: 0;
    background: #fff;
    > div {
      padding: 0;
    }
  `}
`

export const SupportTitle = styled(H2)`
  color: white;
  margin: 48px 0 10px 0;
`

export const Container = styled(Flex)`
  align-items: stretch;
  max-width: 100%;
  min-height: 60vh;
  ${Media.phone`
    display: block;
    margin: .3rem 0 1rem 0;
  `}
`

export const TabWrap = styled.div`
  width: 100%;
`

export const TabHeader = styled.div`
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #e7ebef;
  ${Media.phone`
    display:block;
    overflow-x: auto;
    width: 100%;
    white-space: nowrap;
    font-size: initial;
    padding: 0 0.45rem;
    ${hideScrollbar};
  `}
`

export const TabContent = styled.div`
  ${({ theme: { color } }) => css`
    margin-top: 40px;
    width: 100%;
    height: 300px;
    background-color: ${color.panel};
  `}
`

export const TabTitle = styled.span`
  ${({ theme: { color } }) => css`
    display: inline-block;
    margin: 0 32px;
    padding: 18px 10px;
    a {
      font-size: 20px;
      line-height: 20px;
      :hover {
        color: ${color.primary};
      }
    }
    ${p =>
      p.active &&
      css`
        border-bottom: 3px solid ${color.secondary};
      `}
    ${Media.phone`
      margin: initial;
      padding: .3rem .2rem .28rem .2rem;
      font-size:.3rem;
      :first-child{
        padding-left: 0;
      }
      :last-child{
        padding-right: 0;
      }
      a {
        font-size: .3rem;
      }
    `}
  `}
`
export const MobileMenuContainer = styled.div`
  position: fixed;
  top: 0.6rem;
  height: 100vh;
  left: ${p => (p.isExpand ? 0 : '-280px')};
  transition: all linear 0.3s;
  z-index: 200;
`
export const ExpandIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 1.2rem;
  left: 280px;
  width: 30px;
  height: 30px;
  background-color: ${p => p.theme.color.secondary};
  z-index: 1000;
  img {
    width: 18px;
    height: 18px;
  }
`
export const NavWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  padding: 30px 30px 20px 34px;
  .search-container {
    width: 290px;
    height: 40px;
    button {
      width: 50px;
      padding: 0;
      svg {
        width: 20px;
      }
    }
  }
  ${Media.phone`
    padding: 0;
    flex-wrap: wrap;
    flex-direction: column-reverse;
    align-items: flex-start;
    background: #F5F7FB;
    > div:nth-of-type(1) {
      padding: .4rem .3rem 0rem;
      background: #fff;
      width: 100%;
    }
    > div:nth-of-type(2) {
      margin: .4rem auto .4rem;
    }
  `}
`
